import React, { useEffect, useRef, useState } from 'react';

import { EditBloomerSociety, EditBloomerSocietyRef } from './EditBloomerSociety';
import { EditPersonnalInfos, EditPersonnalInfosRef } from './EditPersonnalInfos';
import { Button } from '@bloomays-lib/ui.shared';
import { BrowserBloomer, BrowserMe, ISociety } from '@bloomays-lib/types.shared';
import { styled } from '@mui/material/styles';

export type InscriptionBloomerProps = {
  onBloomerDataValidated: (data: BrowserBloomer) => Promise<BrowserBloomer | undefined>;
  onSocietyDataValidated: (data: ISociety) => Promise<ISociety | undefined>;
  me: BrowserMe;
  uploading: boolean;
};

const InscriptionBloomer = ({
  onBloomerDataValidated,
  onSocietyDataValidated,
  me,
  uploading = false,
}: InscriptionBloomerProps) => {
  const billingSociety = me?.bloomer?.mission
    ?.findLast((m) => (m.bloomerBillingSociety || []).length > 0)
    ?.bloomerBillingSociety?.findLast(() => true);
  const formPersonnal = useRef<EditPersonnalInfosRef>(null);
  const formSociety = useRef<EditBloomerSocietyRef>(null);
  const [enabled, setEnabled] = useState(!uploading);

  useEffect(() => {
    setEnabled(!uploading);
  }, [uploading]);

  const submitForm = async (e: React.FormEvent<HTMLFormElement>) => {
    // setTimeout to immeditaly disable the button
    setTimeout(() => setEnabled(false), 0);
    e.preventDefault();
    let validated = await formPersonnal?.current?.validate(e);
    if (!validated) {
      // must be set in a setTimeout to avoid a race condition
      setTimeout(() => setEnabled(true), 0);
      return false;
    }
    validated = await formSociety?.current?.validate(e);
    if (!validated) {
      // must be set in a setTimeout to avoid a race condition
      setTimeout(() => setEnabled(true), 0);
      return false;
    }
  };

  const getDisabled = () => {
    return !enabled;
  };

  return (
    <Container>
      <form onSubmit={submitForm} aria-label="Questionnaire Infos OnBoarding">
        <EditPersonnalInfos ref={formPersonnal} me={me} onValidated={onBloomerDataValidated} hideSubmitButton={true} />
        <EditBloomerSociety
          ref={formSociety}
          society={billingSociety}
          onValidated={onSocietyDataValidated}
          hideSubmitButton={true}
        />
        <Button
          id="inscriptionSaveButton"
          // eslint-disable-next-line jsx-a11y/aria-role
          role={'button-onboarding'}
          none={'none'}
          textButton={!enabled ? "En cours d'envoi" : 'Sauvegarder mes données'}
          disable={getDisabled()}
          loading={getDisabled()}
          buttonType="submit"
        />
      </form>
    </Container>
  ) as React.ReactNode;
};

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '55%',

  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    width: '95%',
  },
  margin: '0 auto', // Pour centrer horizontalement
}));

export default InscriptionBloomer;

export { InscriptionBloomer };
